export const LESSON_TYPES = Object.freeze({
  ON_DEMAND: 1,
  LIVE: 2,
  HOMEWORK: 3,
  PRIVATE_REPLAY: 4,
  AUDIO: 5,
})

export const UNKNOWN_LESSON_TYPE_CONFIG = Object.freeze({
  type: 0,
  label: '课时',
  listLabel: '暂不支持',
  tagClass: 'tag-unknown',
  tagType: 'info',
  playbackKind: 'unsupported',
  isKnown: false,
  canTrial: false,
})

export const LESSON_TYPE_CONFIG = Object.freeze({
  [LESSON_TYPES.ON_DEMAND]: Object.freeze({
    type: LESSON_TYPES.ON_DEMAND,
    label: '点播',
    listLabel: '视频',
    tagClass: 'tag-video',
    tagType: '',
    playbackKind: 'video',
    isKnown: true,
    canTrial: true,
  }),
  [LESSON_TYPES.LIVE]: Object.freeze({
    type: LESSON_TYPES.LIVE,
    label: '直播',
    listLabel: '直播',
    tagClass: 'tag-live',
    tagType: 'success',
    playbackKind: 'live',
    isKnown: true,
    canTrial: true,
  }),
  [LESSON_TYPES.HOMEWORK]: Object.freeze({
    type: LESSON_TYPES.HOMEWORK,
    label: '作业',
    listLabel: '作业',
    tagClass: 'tag-homework',
    tagType: 'warning',
    playbackKind: 'homework',
    isKnown: true,
    canTrial: false,
  }),
  [LESSON_TYPES.PRIVATE_REPLAY]: Object.freeze({
    type: LESSON_TYPES.PRIVATE_REPLAY,
    label: '私教课',
    listLabel: '直播',
    tagClass: 'tag-live',
    tagType: '',
    playbackKind: 'liveReplay',
    isKnown: true,
    canTrial: false,
  }),
  [LESSON_TYPES.AUDIO]: Object.freeze({
    type: LESSON_TYPES.AUDIO,
    label: '音频',
    listLabel: '音频',
    tagClass: 'tag-audio',
    tagType: '',
    playbackKind: 'audio',
    isKnown: true,
    canTrial: true,
  }),
})

export function normalizeLessonType(type) {
  const normalizedType = Number(type)
  return Number.isFinite(normalizedType) ? normalizedType : 0
}

export function getLessonTypeConfig(type) {
  const normalizedType = normalizeLessonType(type)
  return (
    LESSON_TYPE_CONFIG[normalizedType] || {
      ...UNKNOWN_LESSON_TYPE_CONFIG,
      type: normalizedType,
    }
  )
}

export function getLessonTypeLabel(type) {
  return getLessonTypeConfig(type).label
}

export function isKnownLessonType(type) {
  return getLessonTypeConfig(type).isKnown
}

export function isAudioLessonType(type) {
  return normalizeLessonType(type) === LESSON_TYPES.AUDIO
}

export function isOnDemandLessonType(type) {
  return normalizeLessonType(type) === LESSON_TYPES.ON_DEMAND
}

export function isOnDemandLikeLessonType(type) {
  return [LESSON_TYPES.ON_DEMAND, LESSON_TYPES.AUDIO].includes(
    normalizeLessonType(type)
  )
}

export function isLiveLikeLessonType(type) {
  return [LESSON_TYPES.LIVE, LESSON_TYPES.PRIVATE_REPLAY].includes(
    normalizeLessonType(type)
  )
}
